import Section from '../Section';

export default class VideoHero extends Section {

}
